import { Mesh } from 'three';
import React from 'react';

export default {
    name: '[pipe]magnet-ventil',
    prototype: 'holes',

    info: {
        tag: ['magnet-ventil'],
        title: 'Magnet Ventil',
        description: 'Magnet Ventil',
        image: require('./magnet-ventil.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 30
            }
        },
        flip_orizzontal: {
            label: 'flip orizzontale',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        },
    },

    render2D: function (element, layer, scene) {

        let width = element.properties.get('width').get('length');
        let flip = element.properties.get('flip_orizzontal');


        if (flip === false) {
            return (
                <g transform={`scale(${width * 0.03} ${width * 0.03}) translate(-19, -7) rotate(90)`}>
                    <rect x="0" y="-5" width="14" height="6" stroke="#000000" fill="#000000" />
                    <path id="2" d="M0 -5 L7 -15 L14 -5" stroke="#000000" fill="#000000" />
                    <line x1="6.5" y1="-14" x2="20" y2="-14" stroke="#000000" strokeWidth="3" />
                    <line x1="20" y1="-13" x2="20" y2="-28" stroke="#000000" strokeWidth="3" />
                    <path d="M0 -23 L7 -13 L14 -23" stroke="#000000" fill="#000000" />
                    <rect x="0" y="-29" width="14" height="6" stroke="#000000" fill="#000000" />
                </g>
            )
        } else {
            return (
                <g transform={`scale(${width * 0.03} ${width * 0.03}) translate(8, 7) rotate(270)`}>
                    <rect x="0" y="-5" width="14" height="6" stroke="#000000" fill="#000000" />
                    <path id="2" d="M0 -5 L7 -15 L14 -5" stroke="#000000" fill="#000000" />
                    <line x1="6.5" y1="-14" x2="20" y2="-14" stroke="#000000" strokeWidth="3" />
                    <line x1="20" y1="-13" x2="20" y2="-28" stroke="#000000" strokeWidth="3" />
                    <path d="M0 -23 L7 -13 L14 -23" stroke="#000000" fill="#000000" />
                    <rect x="0" y="-29" width="14" height="6" stroke="#000000" fill="#000000" />
                </g>
            )
        }

    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
